import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";

import {
	Button,
	Col,
	Divider,
	Dropdown,
	Icon,
	Input,
	Menu,
	message,
	Modal,
	Row,
	Table,
	Typography,
	Upload,
	Select,
	Tag,
	Switch,
	Tooltip,
} from "antd";

import { ReactComponent as InfoLogo } from "./images/info-circle.svg";

import Loader from "components/Loader/Loader";

import emptyImageRollout from "./images/emptyImageRollout.png";

import { fetchFeatureListApi, updateFeatureListApi } from "utils/apiService";
import "./rollout.scss";
import FeatureDetails from "./FeatureDetails";
const { Text } = Typography;
const { Dragger } = Upload;

const FeatureListTable = (props) => {
	
	const columns = [
		{
			title: "Feature Name",
			dataIndex: ["name", "uuid", "description"],
			key: "featureName",
			render: (_, data) => {
				return (
					<div
						style={{
							width: "350px",
							display: "flex",
						}}>
						<div>
							<Text
								style={{
									color: "#181818",
								}}>
								<Link
									to={`${props.location?.pathname}/${data?.uuid}`}
									style={{
										color: "#181818",
										fontWeight: "bold",
										fontSize: "16px",
										lineHeight: "24px",
									}}
									onMouseEnter={(e) => (e.target.style.color = "#fec708")}
									onMouseLeave={(e) => (e.target.style.color = "#181818")}>
									{data.name}
								</Link>
							</Text>
						</div>
						<div
							style={{
								padding: "3px 5px 0px 5px",
							}}>
							<Tooltip
								placement="bottomRight"
								title={
									<span
										style={{
											color: "white",
										}}>
										{data.description ? data.description : "Add description "}
									</span>
								}>
								<InfoLogo
								//   style={{
								//     marginLeft: "5px",
								//     //   marginTop: "4px",
								//   }}
								/>
							</Tooltip>
						</div>
					</div>
				);
			},
		},
		{
			title: "Connection",
			dataIndex: "is_enabled",
			key: "connected",
			render: (data) => {
				return (
					<Tag className={data === true ? "connectedTag" : "notConnectedTag"}>
						<Text
							style={{
								fontSize: "12px",
								lineHeight: "20px",
								color: `${data !== true ? "#CD0005" : "#2A9C0A"}`,
								padding: "2px",
							}}>
							{data ? "Connected" : "Not Connected"}
						</Text>
					</Tag>
				);
			},
		},
		{
			title: "Total User",
			dataIndex: "user_count",
			key: "activeUser",
			render: (data) => {
				return (
					<Text
						style={{
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#181818",
							whiteSpace: "nowrap",
						}}>
						{data || "-"}
					</Text>
				);
			},
		},
		{
			title: "Created On",
			dataIndex: "date_created",
			key: "createdOn",
			render: (data) => {
				const date = new Date(data * 1000);
				return (
					<Text
						style={{
							fontStyle: "normal",
							//   fontWeight: "bold",
							fontSize: "14px",
							lineHeight: "22px",
							color: "#747474",
							whiteSpace: "nowrap",
						}}>
						{/* {data ? `${date.getHours() + ":" + date.getMinutes() + ", " + date.toDateString()}` : "0"} */}
						{data ? data : "0"}
					</Text>
				);
			},
		},
		{
			title: "Status",
			dataIndex: ["is_enabled", "name","uuid"],
			key: "status",
			render: (_, data) => {
				return (
					<Switch
						defaultChecked={data.is_enabled}
						onChange={(value) => {
							let data_temp = {};
							data_temp[data.name] = { is_enabled: value };
							updateFeatureListApi({
								requestData: {
									countryId: JSON.parse(localStorage.getItem("countryData"))?.database_identifier,
									...data_temp,
								},
								res200Callback: (res) => {
									updateisEnable(data.uuid,value);
									message.success("Feature updated successfully");
								},
								resErrorCallback: (res) => {
									message.error("Feature update failed");
								},
							});
						}}
					/>
				);
			},
		},
	];

	const updateisEnable = (uuid,value) =>{
		let featurelist = props.data.features.map((item)=>{
			if(item.uuid === uuid){
				item.is_enabled = value;
			}
			return item;
		});
		props.setfeatureList({...props.data,features:featurelist});
	}

	return (
		<>
			<Table
				// rowSelection={props.noAction ? null : rowSelection}
				columns={(function () {
					// if (props.noAction) {
					// 	return columns.filter((item) => item.key != "x");
					// }
					return columns;
				})()}
				dataSource={props.data.features}
				pagination={{ showQuickJumper: true, pageSize: 10 }}
				style={{ overflow: "none" }}
				loading={props.loading}
			/>
		</>
	);
};

const Rollout = (props) => {
	let { path } = useRouteMatch();

	const [_, forceUpdate] = useReducer((x) => x + 1, 0);
	const [loading, setLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(true);
	const [isRollOutPage, setIsRollOutPage] = useState(true);

	const [featureList, setfeatureList] = useState({
		features: [],
		pageNum: 1,
		pageSize: 50,
		totalPages: 1,
	});

	const loadTable = () => {
		fetchFeatureListApi({
			requestData: {},
			resCallback: () => {
				setLoading(false);
				setTableLoading(false);
			},
			res200Callback: (res) => {
				setfeatureList({
					...featureList,
					features: Object.keys(res.data.feature_list).map((key) => ({ ...res.data.feature_list[key], name: key })),
				});
			},
		});
	};

	useEffect(() => {
	}, [featureList]);

	useEffect(() => {
		loadTable();
	}, []);

	return loading ? (
		<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
			<Loader />
		</Row>
	) : (
		<>
			{isRollOutPage && (
				<>
					{featureList.features.length === 0 ? (
						<Row
							style={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
								padding: "40px 25px 70px",
								margin: "60px auto 20px",
								backgroundColor: "#FAFAFA",
								marginTop: "80px",
							}}>
							<Row>
								<Text
									style={{
										color: "#181818",
										/*fontFamily: "Gotham",*/ fontStyle: "normal",
										fontWeight: "bold",
										fontSize: "24px",
										lineHeight: "39px",
									}}>
									Rollout Features
								</Text>
							</Row>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									justifyContent: "center",
									alignItems: "center",
									backgroundColor: "#FAFAFA",
									marginTop: "30px",
								}}>
								<img
									src={emptyImageRollout}
									alt="Illustration for empty cohort list"
									style={{
										width: "340px",
										height: "340px",
									}}
								/>
								<Text
									style={{
										fontSize: "20px",
										color: "#181818",
										fontWeight: "bold",
										marginTop: "16px",
									}}>
									They are no Rollout Features yet.
								</Text>
								<Text
									style={{
										color: "#747474",
										marginTop: "8px",
										textAlign: "center",
									}}>
									Import rollout features from backend
								</Text>
							</div>
						</Row>
					) : (
						<Row
							style={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
								padding: "40px 25px 70px",
								margin: "60px auto 20px",
								backgroundColor: "#FAFAFA",
								marginTop: "80px",
							}}
							gutter={[12, 48]}>
							<Row
								type="flex"
								align="middle"
								justify="space-between"
								style={{
									marginBottom: "24px",
								}}>
								<Text
									style={{
										color: "#181818",
										/*fontFamily: "Gotham",*/ fontStyle: "normal",
										fontWeight: "bold",
										fontSize: "24px",
										lineHeight: "39px",
									}}>
									Rollout Features
								</Text>
								<Input
									placeholder="Search rollout features"
									suffix={<Icon type="search"></Icon>}
									style={{ width: "320px", background: "#FFFFFF" }}></Input>
							</Row>
							<FeatureListTable
								{...props}
								loading={tableLoading}
								data={featureList}
								setfeatureList={setfeatureList}
								isRollOutPage={setIsRollOutPage}
							/>
						</Row>
					)}
				</>
			)}
		</>
	);
};

export default Rollout;
